import generateTypes from '../../utils/generateTypes';

export const GET_EVENT = generateTypes('GET_EVENT');
export const RESET_EVENT = generateTypes('RESET_EVENT');
